import { useLocation } from "react-router-dom";
import Nullable = Common.Nullable;

export function useQuery(): URLSearchParams {
  return new URLSearchParams(useLocation().search);
}

export function useQueryParam(name: string): Nullable<string> {
  const params = useQuery();

  return getQueryParam(name, params);
}

export function getQueryParam(name: string, search: URLSearchParams): Nullable<string> {
  const lowerCaseName = name.toLowerCase();

  for (const [key, value] of search.entries()) {
    if (key.toLowerCase() === lowerCaseName) {
      return value;
    }
  }

  return null;
}
